// « Se reconnecter » : efface la session morte de cet appareil, puis ouvre la
// bonne page de connexion avec un retour automatique vers la page quittée.
// `sessionLogout` est importé à la demande : ce module est chargé par
// `toast.ts`, que tout le reste de l'app importe, et un import direct du
// client Supabase ici créerait un cycle au démarrage.

export function signInPathFor(pathname: string): string {
  // Comparaison sur le chemin en minuscules : un lien copié ou tapé avec une
  // majuscule ne doit pas tomber dans le cas par défaut.
  const chemin = pathname.toLowerCase();
  if (chemin.startsWith("/admin")) return "/auth/admin";
  // Pages côté client : le tunnel de réservation et ses annexes. Y envoyer un
  // client signé sur `/auth/owner` déclenche un « accès refusé » (OwnerAuth
  // refuse les clients).
  if (
    chemin.startsWith("/client") ||
    chemin.startsWith("/book") ||
    chemin.startsWith("/pay/") ||
    chemin.startsWith("/confirmer-rdv/") ||
    chemin.startsWith("/en/confirmer-rdv/")
  ) {
    return "/auth/client";
  }
  return "/auth/owner";
}

export async function goToSignIn(): Promise<void> {
  const { pathname, search } = window.location;
  try {
    const { discardLocalSession } = await import("@/lib/sessionLogout");
    await discardLocalSession();
  } catch {
    // La page de connexion repartira de toute façon sans session valide.
  }
  const cible = signInPathFor(pathname);
  const retour = pathname.startsWith("/auth/") ? "" : `?returnTo=${encodeURIComponent(`${pathname}${search}`)}`;
  // Rechargement complet volontaire, y compris dans l'app native : une
  // déconnexion sans passer par le navigateur laisse `initialAuthDone` à
  // `false` sans rien pour le remettre à zéro, et ce toast vit hors du
  // routeur.
  window.location.assign(`${cible}${retour}`);
}
